import { render } from "./InventoryItem.html?vue&type=template&id=66afc5c8&scoped=true"
import script from "./InventoryItem.vue?vue&type=script&lang=js"
export * from "./InventoryItem.vue?vue&type=script&lang=js"

import "./InventoryItem.vue?vue&type=style&index=0&id=66afc5c8&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66afc5c8"]])

export default __exports__